import { render, staticRenderFns } from "./Unavailable.vue?vue&type=template&id=de8e2460&scoped=true&"
import script from "./Unavailable.vue?vue&type=script&lang=js&"
export * from "./Unavailable.vue?vue&type=script&lang=js&"
import style0 from "./Unavailable.vue?vue&type=style&index=0&id=de8e2460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8e2460",
  null
  
)

export default component.exports